module.exports = __webpack_public_path__ + "static/media/21ECLAC40.d33e4e22.jpg";